document.addEventListener('tomitLoaded', function(e) {
  let inventoryItem = document.querySelector('#pos_tomit_inventoryLocationInformation');
  if (inventoryItem != null) {
    let inventoryItemProductId = inventoryItem.getAttribute('data-tomit-product-id');
    let inventoryItemVariantId = inventoryItem.getAttribute('data-tomit-variant-id');
    tomitProductInventoryInfo.getProductsInventoryInformation([inventoryItemProductId]).then(function(e) {
      inventoryItem.append(tomitProductInventoryInfo.listInventory(e[inventoryItemProductId].product.variants[inventoryItemVariantId].inventoryItem.locations, 1));
      
      let inventoryLocationContainer = document.querySelector('#tomit_inventory_list');
      inventoryLocationContainer.classList.add('form-field-select-wrapper');
      
      let inventoryLocationList = document.querySelector('#tomit_inventory_list select');
      inventoryLocationList.setAttribute('id','tomit_inventory_list_select');
      inventoryLocationList.classList.add('form-field-input', 'form-field-select', 'form-field-filled');
      
      let inventoryLocationListLabel = document.createElement('label');
      inventoryLocationListLabel.setAttribute('for','tomit_inventory_list_select');
      inventoryLocationListLabel.classList.add('form-field-title');
      inventoryLocationListLabel.innerText = 'Store';
      inventoryLocationList.after(inventoryLocationListLabel);
           
      let inventoryLocationListChevron = document.createElementNS('http://www.w3.org/2000/svg','svg');
      inventoryLocationListChevron.setAttribute('aria-hidden',true);
      inventoryLocationListChevron.setAttribute('focusable',false);
      inventoryLocationListChevron.setAttribute('role','presentation');
      inventoryLocationListChevron.setAttribute('width',8);
      inventoryLocationListChevron.setAttribute('height',6);
      inventoryLocationListChevron.setAttribute('viewBox','0 0 8 6');
      inventoryLocationListChevron.setAttribute('fill','none');
      inventoryLocationListChevron.classList.add('icon-chevron-down');
      inventoryLocationListChevron.innerHTML = '<path class="icon-chevron-down-left" d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" style="user-select: auto;"></path>\
      <path class="icon-chevron-down-right" d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" style="user-select: auto;"></path>';
      inventoryLocationListLabel.after(inventoryLocationListChevron);
      
      inventoryLocationList.addEventListener('change', enableDisableCNCATC);
      enableDisableCNCATC();
    });
  }
});
document.addEventListener('tomitProductLoaded', function(e) {
  let inventoryLocationContainer = document.querySelector('#tomit_inventory_list');
  if (inventoryLocationContainer != null) {
    inventoryLocationContainer.classList.add('form-field-select-wrapper');

    let inventoryLocationList = document.querySelector('#tomit_inventory_list select');
    inventoryLocationList.setAttribute('id','tomit_inventory_list_select');
    inventoryLocationList.classList.add('form-field-input', 'form-field-select', 'form-field-filled');
	
    let inventoryLocationListLabelExists = document.querySelector('#tomit_inventory_list .form-field-title');
    if (inventoryLocationListLabelExists == null) {
      let inventoryLocationListLabel = document.createElement('label');
      inventoryLocationListLabel.setAttribute('for','tomit_inventory_list_select');
      inventoryLocationListLabel.classList.add('form-field-title');
      inventoryLocationListLabel.innerText = 'Store';
      inventoryLocationList.after(inventoryLocationListLabel);

      let inventoryLocationListChevron = document.createElementNS('http://www.w3.org/2000/svg','svg');
      inventoryLocationListChevron.setAttribute('aria-hidden',true);
      inventoryLocationListChevron.setAttribute('focusable',false);
      inventoryLocationListChevron.setAttribute('role','presentation');
      inventoryLocationListChevron.setAttribute('width',8);
      inventoryLocationListChevron.setAttribute('height',6);
      inventoryLocationListChevron.setAttribute('viewBox','0 0 8 6');
      inventoryLocationListChevron.setAttribute('fill','none');
      inventoryLocationListChevron.classList.add('icon-chevron-down');
      inventoryLocationListChevron.innerHTML = '<path class="icon-chevron-down-left" d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" style="user-select: auto;"></path>\
      <path class="icon-chevron-down-right" d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" style="user-select: auto;"></path>';
      inventoryLocationListLabel.after(inventoryLocationListChevron);
    }

    inventoryLocationList.addEventListener('change', enableDisableCNCATC);
  }
  enableDisableCNCATC();
});
document.addEventListener('tomitVariantChanged', function(e) {
  let inventoryLocationStyled = document.querySelector('#tomit_inventory_list.form-field-select-wrapper');
  if (inventoryLocationStyled == null) {
  	let inventoryLocationContainer = document.querySelector('#tomit_inventory_list');
    if (inventoryLocationContainer != null) {
      inventoryLocationContainer.classList.add('form-field-select-wrapper');

      let inventoryLocationList = document.querySelector('#tomit_inventory_list select');
      inventoryLocationList.setAttribute('id','tomit_inventory_list_select');
      inventoryLocationList.classList.add('form-field-input', 'form-field-select', 'form-field-filled');

      let inventoryLocationListLabelExists = document.querySelector('#tomit_inventory_list .form-field-title');
      if (inventoryLocationListLabelExists == null) {
        let inventoryLocationListLabel = document.createElement('label');
        inventoryLocationListLabel.setAttribute('for','tomit_inventory_list_select');
        inventoryLocationListLabel.classList.add('form-field-title');
        inventoryLocationListLabel.innerText = 'Store';
        inventoryLocationList.after(inventoryLocationListLabel);

        let inventoryLocationListChevron = document.createElementNS('http://www.w3.org/2000/svg','svg');
        inventoryLocationListChevron.setAttribute('aria-hidden',true);
        inventoryLocationListChevron.setAttribute('focusable',false);
        inventoryLocationListChevron.setAttribute('role','presentation');
        inventoryLocationListChevron.setAttribute('width',8);
        inventoryLocationListChevron.setAttribute('height',6);
        inventoryLocationListChevron.setAttribute('viewBox','0 0 8 6');
        inventoryLocationListChevron.setAttribute('fill','none');
        inventoryLocationListChevron.classList.add('icon-chevron-down');
        inventoryLocationListChevron.innerHTML = '<path class="icon-chevron-down-left" d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" style="user-select: auto;"></path>\
        <path class="icon-chevron-down-right" d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square" style="user-select: auto;"></path>';
        inventoryLocationListLabel.after(inventoryLocationListChevron);
      }
      inventoryLocationList.addEventListener('change', enableDisableCNCATC);
    }
  }
  enableDisableCNCATC();
});

function enableDisableCNCATC() {
  let CNCContainer = document.querySelector('.product-form--cnc');
  let CNCContainerSelect = document.querySelector('.product-form--cnc select');
  if (CNCContainerSelect != null) {
    CNCContainer.classList.remove('display_none');
  } else {
    CNCContainer.classList.add('display_none');
  }
  let ATCButton = document.querySelector('#product-form--atc-button_main');
  let CNCButton = document.querySelector('#product-form--cnc-button_main');
  let tomitList = document.querySelector('#tomit_inventory_list select');
  if (tomitList != null && tomitList.selectedIndex != 0 && ATCButton != null) {
    ATCButton.classList.add('disabled');
    ATCButton.setAttribute('disabled', '');
    if (CNCButton != null) {
      CNCButton.classList.remove('disabled');
      CNCButton.removeAttribute('disabled');
    }
  }
  if (tomitList != null && tomitList.selectedIndex == 0 && ATCButton != null) {
    ATCButton.classList.remove('disabled');
    ATCButton.removeAttribute('disabled');
    if (CNCButton != null) {
      CNCButton.classList.add('disabled');
      CNCButton.setAttribute('disabled', '');
    }
  }
}
function addCNCProductToCart() {
  let inventoryItem = document.querySelector('#pos_tomit_inventoryLocationInformation');
  let inventoryItemProductId = null;
  let inventoryItemVariantId = null;
  if (inventoryItem != null) {
    inventoryItemProductId = inventoryItem.getAttribute('data-tomit-product-id');
    inventoryItemVariantId = inventoryItem.getAttribute('data-tomit-variant-id');
    let variantIDField = document.querySelector('.variants-ui[name="id"]');
    variantIDField.value = inventoryItemVariantId;
    variantIDField.closest('form').submit();
  } else {
    let productForm = document.querySelector('.product-form--regular form');
    if (productForm != null) {
      productForm.submit();
    }
  }
}